import { render, staticRenderFns } from "./SellerCallLogs.vue?vue&type=template&id=87245f8c&scoped=true"
import script from "./SellerCallLogs.vue?vue&type=script&lang=js"
export * from "./SellerCallLogs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87245f8c",
  null
  
)

export default component.exports